<template>
  <Page>
    <div class="space-y-3">
      <div class="bg-background-card rounded-lg shadow-card overflow-hidden p-6">
        <div class="flex items-center">
          <div class="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center mr-4">
            <i class="fa-solid fa-chart-column text-xl"></i>
          </div>
          <div>
            <h1 class="text-2xl font-bold text-primary">Reports</h1>
            <p class="text-secondary">Browse the available reports for your selected project</p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        <router-link
          v-for="report in reportCatalog"
          :key="report.id"
          :to="report.route"
          class="bg-background-card rounded-lg shadow-card border border-border p-5 transition hover:shadow-lg hover:border-primary/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <div class="flex items-start justify-between gap-3">
            <div class="flex items-center gap-3">
              <div class="w-9 h-9 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <i :class="['fa-solid', report.icon]"></i>
              </div>
              <div>
                <h2 class="text-lg font-semibold text-text">{{ report.title }}</h2>
                <p class="text-sm text-text-light mt-1">{{ report.description }}</p>
              </div>
            </div>
            <span
              class="text-xs px-2 py-1 rounded-full"
              :class="report.status === 'available' ? 'bg-success/15 text-success' : 'bg-secondary/15 text-secondary'"
            >
              {{ report.status === 'available' ? 'Available' : 'Coming Soon' }}
            </span>
          </div>
        </router-link>
      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">
import Page from '@/shared/components/layouts/Page.vue';
import { reportCatalog } from '../config/reportCatalog';

definePage({
  meta: {
    title: 'Reports',
  },
});
</script>
